<template>
  <div class="filteritem">
  <v-select 
    class="drop font-weight-bold text-text text-subtitle-1"
    hide-details
    density="compact"
    variant="underlined"
    v-model="localValue"
    :name="filterKey" 
    :item-props="$PAG.itemProps" 
    :label="selectorItem.SelectorName" 
    :items="items"
    :menu-props="selectOptionsWhiteBackground"
  />
  </div>
</template>


<script setup>
const { $PAG } = useNuxtApp()

const props = defineProps({
  selectorItem: {
    type: Object,
    default: {},
  },  
  pagData: {
    type: Object,
    default: {},
  }, 
  modelValue: {  // Accept v-model
    type: [String, Number, Object],
    default: "",
  }, 
})

const emit = defineEmits(['update:modelValue'])

const filterKey = computed(() => 
  $PAG.getFilterKey(props.selectorItem.AttribuutSelectorName, props.pagData)
)
const items = computed(() => 
  $PAG.addItems(props.selectorItem.AttribuutSelectorName, props.pagData, props.selectorItem, false)
)

// Local value with two-way binding
const localValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})
</script>